"use client";

import type { LinkProps } from "next/link";
import { Link } from "../../../navigation";
import UnchainedButton, {
  ButtonProps as UnchainedButtonProps,
} from "../../common/components/Button";
import useCMSPageByID from "../../cms/hooks/server/useCMSPageByID";
import { useLocale } from "next-intl";

export interface ButtonProps
  extends Omit<UnchainedButtonProps, "href" | "onClick">,
    Omit<LinkProps, "href"> {
  size?: "sm-small" | "small" | "medium" | "large";
  iconSize?: "small" | "normal" | "large";
  appearance:
    | "primary"
    | "secondary"
    | "tertiary"
    | "quaternary"
    | "link"
    | "input"
    | "round"
    | "danger";
  hidden?: boolean;
  href?: LinkProps["href"];
  tabIndex?: number;
}

const Button: React.FC<ButtonProps> = ({
  appearance,
  size,
  href,
  children,
  hidden,
  ...rest
}) => {
  const locale = useLocale();
  const possiblePageId =
    (href as string)?.split && (href as string)?.split("pages://")?.[1];
  const { page } = useCMSPageByID({
    pageId: possiblePageId,
    locale,
  });
  if (hidden) return null;
  if (!href) {
    return (
      <UnchainedButton
        className="publicare-button"
        data-size={size}
        data-appearance={appearance}
        {...rest}
      >
        {children}
      </UnchainedButton>
    );
  }
  const normalizedHref = page?._r || href;

  return (
    <UnchainedButton
      href={normalizedHref}
      WrapperComponent={Link}
      target={rest?.target || "_self"}
      className="publicare-button"
      data-size={size}
      data-appearance={appearance}
      {...rest}
    >
      {children}
    </UnchainedButton>
  );
};

export default Button;
